import React from 'react';
import {useHomeDispatch} from "../../store/slices/home/homeSlice";
import {getFeaturedContent} from "../../store/slices/home/actions";
import {Home} from "../../components/home/Home";
import {useDocumentTitle} from "../../hooks/useDocumentTitle";

export const HomePage: React.FC = () => {
    const homeDispatch = useHomeDispatch();
    useDocumentTitle(null);

    React.useEffect(() => {
        homeDispatch(getFeaturedContent());
    },[homeDispatch]);

    return (
            <Home />
    );
};
